import ApiBase, { baseUrl } from '.';

export default class BigBlueButtonServiceApi extends ApiBase {
  constructor(token) {
    super(`${baseUrl}/api/services/app/BigBlueButtonService`, token);
  }

  joinRoom(id, elementType, state, execution) {
    return this.authHttp.post(`${this.baseUrl}/JoinRoom`, {
      id,
      elementType,
      state,
      execution
    });
  }
}
